
  import moment from 'moment';
  import _ from 'lodash';
  import gql from "graphql-tag";
  import {printPDF} from "./printPDF.js";
  import api from "../api.ts";
  export const printReport = {
    name: 'PrintReport',
    mixins: [printPDF],
    data() {
      return {
        printreport_data:{},
        printreport_data2:{},
        printreport_images:{},
        printreport_advise:{},
        printreport_id:0,
        printreport_isHostory:false,
        printreport_isDownLoad:false,
        printreport_descriptionArr: [],
        printreport_reportImages: {},
        printreport_age: 0,
        printreport_username: "",
        printreport_realname: "",
        printreport_showImgArr: [],
        printreport_initialTime:-30610253143000, // 初始时间1000-01-01 00:00:00
        printreport_printMask:false,
        iframeStatus:false,
        printreport_title:""
      }
    },
    methods: {
      printPropsHostory(){
        this.printreport_data = this.patientinfo;
        this.printreport_data2 = this.diagnoseinfo[printIndex];
        this.printreport_images = this.reportObj;
        this.printreport_isHostory = false;
        this.printreport_isDownLoad = this.isDownLoad;
        this.printreport_advise = this.diagnoseinfo[diagnoseIndex].doctor_suggestion;
      },
      async PrintSubmit() {
        try {
          await this.postInfo();
          if(this.printreport_isHostory) {
            await this.PrintTimeSubmit();
          }
        } catch(error) {
          
          this.$message.error(error.message.split(":")[1]);
        }
      },
      async PrintTimeSubmit() {// 提交照片打印时间
        let newgql = "";
        if (this.printreport_showImgArr.length > 0) {
          let nowTime = moment().format("YYYY-M-D HH:mm:ss");
          for (let i = 0; i < this.printreport_showImgArr.length; i++) {
            newgql += `m${i}:modifyImage(id:${this.printreport_showImgArr[i].id},print_time:"${nowTime}"),`
          }
          let res = await this.$apollo.mutate({
            mutation: gql`mutation{${newgql}}`
          });
        }
      },
      async showimgData(){
        this.printreport_showImgArr = [];
        let self = this;
        if (!_.isEmpty(this.printreport_images)) {
          if (this.printreport_isHostory) {
            for (let key in this.printreport_images) {
              if (key === "bc" || key === "bl" || key === "ct" || key === "general" || key === "skin") {
                let tempImg = _.cloneDeep(self.printreport_images[key].imgs);
                for (let j = 0; j < self.printreport_showImgArr.length; j++) {
                  self.printreport_showImgArr[j].src = self.printreport_showImgArr[j].src.replace(api.server+"/skin_images/", "skin_images/");
                  self.printreport_showImgArr[j].src = self.printreport_showImgArr[j].src.split("?")[0];
                }
                self.printreport_showImgArr.push(...tempImg);
              }
            }
          } else {
            for (let key in this.printreport_images) {
              if (key === "bc" || key === "bl" || key === "ct" || key === "general" || key === "skin") {
                let tempImg = _.cloneDeep(self.printreport_images[key].imgs);
                for (let j = 0; j < self.printreport_showImgArr.length; j++) {
                  self.printreport_showImgArr[j].src = self.printreport_showImgArr[j].src.replace(api.server+"/skin_images/", "skin_images/thumbnails/");
                }
                self.printreport_showImgArr.push(...tempImg);
              }
            }
            _.remove(self.printreport_showImgArr, (n) => {
              return n.print_time === self.printreport_initialTime;
            });
          }

        }
    }
    },
    async created() {
      this.printreport_realname = this.$store.state.me;
      this.printreport_realname = localStorage.getItem("me");
      let current = Number(moment(this.printreport_data.birthday).format("YYYYMMDD").substring(0, 4));
      let end = Number(moment().format("YYYYMMDD").substring(0, 4));
      this.printreport_age = end - current;
      this.printreport_username = sessionStorage.getItem("printreport_username");
    },
  };


